export default {
      id: "ar_dechets-usage",
      viewBox: "0 0 75 75",
      url: "../dist/images/" + "sprite.svg#ar_dechets-usage",
      toString: function () {
        return this.url;
      }
    }